import { makeObservable, observable, action, reaction } from 'mobx';
import axios from 'axios';

class switchStore {
  editor_mode=false;
  par=null;

  constructor(par) {
    this.par=par;
    makeObservable(this, {
      editor_mode: observable,
    })
  }

}

/*
decorate(switchStore,{
  editor_mode:observable,
});
*/

export default switchStore;
